import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionResultsMetadataMap } from "components/BulkActions/helpers";
import {
  BulkActionResultTabs,
  BulkActionsResult,
  BulkActionsStep,
} from "components/BulkActions/types";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import Typography from "ds/components/Typography";
import { SpaceAccessLevel } from "types/generated";
import SpacePath from "components/SpacePath";
import TextEllipsis from "ds/components/TextEllipsis";
import Badge from "ds/components/Badge";
import { FlowsProjectRoleBindingView } from "shared/Flows/Projects/useFlowsProject/types";

type FlowsProjectDetailsRolesBulkActionsResultItemProps = {
  roleBinding: FlowsProjectRoleBindingView;
  tab: BulkActionResultTabs;
  resultsMetadata: BulkActionResultsMetadataMap;
  status: BulkActionsResult;
  stopExecution: () => void;
};

const FlowsProjectDetailsRolesBulkActionsResultItem = ({
  roleBinding,
  tab,
  resultsMetadata,
  status,
  stopExecution,
}: FlowsProjectDetailsRolesBulkActionsResultItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";
  const hasAccessToSpace = roleBinding.space.accessLevel !== SpaceAccessLevel.None;

  return (
    <BulkActionsDrawerItem key={roleBinding.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <BulkActionsDrawerItemStatusIcon result={status} />
        <Box direction="column" gap="medium" grow="1" zeroMinWidth fullWidth>
          {roleBinding.role.isSystem ? (
            <Box align="center" fullWidth gap="medium">
              <TextEllipsis tooltip={roleBinding.role.name} tooltipWidthMode="maxWidthSm">
                {(props) => (
                  <Typography {...props} tag="p" variant="p-body3">
                    {roleBinding.role.name}
                  </Typography>
                )}
              </TextEllipsis>

              <Badge type="strong" variant="blue" text="SYSTEM" />
            </Box>
          ) : (
            <BulkActionsDrawerItemLink
              link={`/settings/role/${roleBinding.role.id}`}
              text={roleBinding.role.name}
              step={BulkActionsStep.Results}
              itemCategory={tab}
            />
          )}

          <Box align="center" zeroMinWidth>
            <SpacePath
              spaceId={roleBinding.space.id}
              fallbackName={roleBinding.space.name}
              disabled={!hasAccessToSpace}
              tooltip={!hasAccessToSpace ? "You don't have access to this space" : undefined}
            />
          </Box>
        </Box>

        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {resultsMetadata.get(roleBinding.id)?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.get(roleBinding.id)?.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default FlowsProjectDetailsRolesBulkActionsResultItem;
